import { PrepareCalculationDatRequest } from "@bundles/damage-calculation-dat/data/repositories/prepareCalculation"
import { TitleType } from "@tm/models"
import { SummaryState } from "../model"

export const createDatCalculationRequest = (state: SummaryState): PrepareCalculationDatRequest => {
    const { fields, useCatalogHourlyRates, datVinSearchIsValid, isGermanOrAustrianVehicle } = state

    const titles = {
        [TitleType.Undefined]: undefined,
        [TitleType.Mister]: "titleMr",
        [TitleType.Miss]: "titleMrs",
        [TitleType.Company]: "titleCompany",
    }

    const request: PrepareCalculationDatRequest = {
        vehicleInfo: {
            registrationDate: fields.initialRegistration,
            ...(isGermanOrAustrianVehicle && {
                kbaNo: fields.registrationNo,
                kbaNrs: fields.registrationNos,
            }),
            certificateNumber: fields.registrationNo,
            vin: fields.vin,
            licenseNumber: fields.plateNumber,
            mileAge: fields.mileage,
        },
        customerInfo: {
            title: titles[fields.titleType!],
            firstName: fields.firstName,
            lastName: fields.lastName,
            street: fields.street,
            streetNo: fields.streetNo,
            country: fields.country,
            zip: fields.zip,
            city: fields.city,
            email: fields.email,
            phone: fields.phone,
            companyName: fields.companyName,
        },
        transactionDescription: fields.processName,
        useCatalogHourlyRates: useCatalogHourlyRates || false,
        getDatVehicleData: datVinSearchIsValid,
    }

    return request
}
